function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #discovoadorSVG .highlight {\n        fill: transparent;\n        /* fill: #c7e22b; */\n      }\n\n      #discovoadorSVG .cls-2 {\n        fill: #461c58;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "discovoadorSVG",
  "data-name": "Camada 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fundo_nave",
  "data-name": "Fundo nave"
}, /*#__PURE__*/React.createElement("path", {
  className: "highlight",
  d: "M107.73,66.1h-21s-32,4.3-32-20h0a44,44,0,0,1,44-44h0a44,44,0,0,1,44,44h0C142.73,70.4,107.73,66.1,107.73,66.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Nave"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M46.65,87.41,40,94a5.35,5.35,0,0,0-2-.25,7.86,7.86,0,0,0-.24,15.71h0a7.74,7.74,0,0,0,7.85-7.85,3.21,3.21,0,0,0-.24-1.48L56.71,88.88C53.27,88.39,49.84,87.9,46.65,87.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M158.84,95h0a4.86,4.86,0,0,0-2,.24l-7.61-7.85c-3.2.49-6.63,1-10.07,1.47l12,12.52c0,.49-.25,1-.25,1.47a7.83,7.83,0,0,0,7.37,7.86h0a7.87,7.87,0,0,0,7.86-7.61,7.44,7.44,0,0,0-7.37-8.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M144.11,33.89A46.52,46.52,0,0,0,86.66,1.73c-.24,0-.49.24-.73.24A48.59,48.59,0,0,0,54,33.4c-7.86,1-15.71,2.45-23.32,4.17C10.31,42.48,0,49.35,0,57.7q0,9.21,15.47,15.47A112.89,112.89,0,0,0,30.2,77.83c17.92,4.42,41.73,6.88,67,6.88s49.1-2.46,67.27-6.88c20.37-4.91,30.68-11.78,30.68-20.13C195.42,45.18,171.61,37.57,144.11,33.89ZM13,60.65c-2.7-.25-4.91-1.72-4.66-3.44s2.45-2.45,5.4-2.21,4.91,1.72,4.66,3.44S15.71,60.89,13,60.65ZM98.45,78.32c-2.7,0-4.91-1.47-4.91-2.94s2.45-2.7,5.15-2.7,4.91,1.47,4.91,2.94-2.45,2.95-5.15,2.7Zm39.77-30.93c0,2.7-2.21,5.4-6.14,7.61-15.47,8.84-51.56,8.84-66.53,0-3.68-2.21-5.65-4.66-5.65-7.36A39.61,39.61,0,0,1,99.43,8.36,38.92,38.92,0,0,1,138.22,47.39Zm43.7,12.28c-2.7-.25-4.91-1.72-4.67-3.44s2.46-2.46,5.4-2.21,4.91,1.72,4.67,3.44S184.62,59.91,181.92,59.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M84.21,19.4a33.12,33.12,0,0,0-14,15,3.24,3.24,0,0,0,1.48,4.17,2.94,2.94,0,0,0,3.92-1.47,26.82,26.82,0,0,1,11.3-12,3.15,3.15,0,0,0,1.23-4.17A2.78,2.78,0,0,0,84.21,19.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M26.17,222.32l4.59-14,7,2.29-4.59,14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M35.31,194.3l4.58-14,7,2.29-4.58,14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M44.14,166.27l4.59-14,7,2.29-4.59,14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M53.49,138.44l4.58-14,7,2.29-4.59,14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M62.62,110.42l4.58-14,7,2.29-4.58,14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M158.94,210.7l7-2.3,4.59,14-7,2.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M149.61,182.71l7-2.3,4.59,14-7,2.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M140.53,154.47l7-2.3,4.59,14-7,2.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M131.45,126.49l7-2.3,4.59,14-7,2.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M122.12,98.49l7-2.29,4.59,14-7,2.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M70.82,155.41l17.43-30.19,30.19,17.43L101,172.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M107.43,177.51l16.76-10.69,10.69,16.77-16.76,10.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M83.4,206l3.9-19.5,19.5,3.9-3.9,19.5Z"
})));

function SvgDiscovoador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195.18 224.7",
    width: "100px",
    height: "125px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovoador);
export default __webpack_public_path__ + "static/media/discovoador.5e243919.svg";
export { ForwardRef as ReactComponent };